import React from "react";

export default function CalendarTooltip({ data, date }) {
  if (!data || !date) return null;

  return (
    <div
      className="
            absolute
            z-50
            bg-gray-950
            border
            border-gray-700
            rounded-xl
            p-4
            shadow-xl
            w-64
        "
    >
      <div className="text-white font-bold mb-3">{date.toDateString()}</div>

      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-400">⭐ Score</span>

          <span className="text-white font-bold">{data.averageScore}</span>
        </div>

        <div className="flex justify-between">
          <span className="text-gray-400">😊 Mood</span>

          <span className="text-white">{data.averageMood || "-"}</span>
        </div>

        <div className="flex justify-between">
          <span className="text-gray-400">⚡ Energy</span>

          <span className="text-white">{data.averageEnergy || "-"}</span>
        </div>

        <div className="flex justify-between">
          <span className="text-gray-400">⏱ Duration</span>

          <span className="text-white">{data.duration} min</span>
        </div>

        <div className="flex justify-between">
          <span className="text-gray-400">📌 Activities</span>

          <span className="text-white">{data.activities}</span>
        </div>
      </div>
    </div>
  );
}
